import { render, staticRenderFns } from "./ArticleBodyMultipageNavigation.vue?vue&type=template&id=8e465df4"
import script from "./ArticleBodyMultipageNavigation.vue?vue&type=script&lang=ts"
export * from "./ArticleBodyMultipageNavigation.vue?vue&type=script&lang=ts"
import style0 from "./ArticleBodyMultipageNavigation.vue?vue&type=style&index=0&id=8e465df4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports